import { render, staticRenderFns } from "./CountdownTimer.vue?vue&type=template&id=20f67b69&"
import script from "./CountdownTimer.vue?vue&type=script&lang=js&"
export * from "./CountdownTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports